import React from "react";
import style from "css/workspace.module.css";
import Questions from "components/app/questions";
import { useMediaQuery } from "react-responsive";
import SEOMeta from "components/app/SEOMeta";
import Consult from "components/device/neat/consult";

function Presentation(props) {
  const isMobile = useMediaQuery({ query: "(max-width: 767px)" });
  const isTablet = useMediaQuery({
    query: "(min-width: 768px) and (max-width: 1024px)",
  });
  const ptInfo = [
    {
      id: 1,
      ex: "ClickShare experiences 01",
      txt: "일하는 곳이 집이든 사무실이든 참가자의 모습이 선명하게 보이고 목소리가 명확히 들린다면 진정한 상호작용이 일어나고 생산적인 대화가 가능합니다. ClickShare를 사용하면 더 간편하게 협업을 수행할 수 있습니다.",
      title: "회의 역량 강화",
      img: "img/smartspace/clickShareImg14.png",
      img_m: "img/smartspace/clickShareImg14_m.png",
    },
    {
      id: 2,
      ex: "ClickShare experiences 02",
      txt: "기존의 회의실 장비를 사용하거나 올인원 회의 솔루션 그리고 여러분의 노트북과 믿을 수 있는 화상 회의 플랫폼을 그대로 사용할 수 있습니다. 어떤 회의실이든 상관없으며 게스트도 원하는 기기로 회의에 참가할 수 있습니다.",
      title: "맞춤화된 솔루션",
      img: "img/smartspace/clickShareImg18.png",
      img_m: "img/smartspace/clickShareImg18_m.png",
    },
    {
      id: 3,
      ex: "ClickShare experiences 03",
      txt: "노트북에서 마치 전화 통화를 하는 것처럼 간단하게 높은 품질의 회의를 진행할 수 있습니다.\n 번거로운 조작판이나 암호, 전선을 사용할 필요가 없습니다.",
      title: "생활을 편리하게 해주는 솔루션",
      img: "img/smartspace/clickShareImg19.png",
      img_m: "img/smartspace/clickShareImg19_m.png",
    },
    {
      id: 4,
      ex: "ClickShare experiences 04",
      txt: "새로운 하이브리드 근무 환경을 안심하고 즐길 수 있도록 보안과 안정성, 지속가능성, 사용 편의성이 설계에 포함되었습니다. 또한 시스템을 항상 최신 상태를 유지하도록 정기적으로 업데이트합니다.",
      title: "안심할 수 있는 솔루션",
      img: "img/smartspace/clickShareImg20.png",
      img_m: "img/smartspace/clickShareImg20_m.png",
    },
  ];

  return (
    <>
      <SEOMeta
        title="무선 컨퍼런싱 ClickShare, 리브테크놀로지"
        description="리브테크놀로지 riv Technology - 무선 컨퍼런싱 ClickShare"
        keywords="리브테크놀로지, 리브테크, 리브, riv, riv Technology, neat, 스마트 회의실, 화상회의, 무선 컨퍼런싱 ClickShare"
      />
      <div
        className={style.wrapper}
        style={props.type === "popup" ? { marginTop: 0 } : {}}
      >
        <div
          className={style.ptWrap1}
          style={props.type === "popup" ? { paddingTop: 0 } : {}}
        >
          <p>
            <font>회의실 Wireless 환경 </font>
            {"\n"} 무선 컨퍼런싱
          </p>
          <img
            alt=""
            src={
              `${process.env.REACT_APP_CLIENT_URL}` +
              "img/smartspace/clickShareImg.png"
            }
          />
        </div>
        <div className={style.ptWrap2}>
          <p>
            <font>ClickShare </font>는 바코(BARCO)에서{"\n"} 개발한 무선
            프레젠테이션 시스템으로, <br />
            회의실이나 강의실에서 사용자가{"\n"} 간편하게 화면을 공유하고{"\n"}{" "}
            협업할 수 있게 해주는 솔루션입니다.
          </p>
          <video
            autoplay
            controls
            src={`${process.env.REACT_APP_CLIENT_URL}video/clickshare.mp4`}
          ></video>
        </div>
        <div className={style.ptWrap3}>
          <p>필요한 건 오직</p>
          <p>
            <font>Button</font> 또는 <font>App!{"\n"}</font> 그리고{" "}
            <font>클릭!</font>
          </p>
          <p>
            ClickShare 버튼이나 앱을 통해{" "}
            <span>단 한 번의 클릭으로 7초 이내에 회의를 시작</span>할 수
            있습니다.
          </p>
          {!isMobile && !isTablet ? (
            <img
              alt=""
              src={
                `${process.env.REACT_APP_CLIENT_URL}` +
                "img/smartspace/clickShareImg3.png"
              }
            />
          ) : (
            <div className={style.ptWrap3_img_group}>
              <img
                alt=""
                src={
                  `${process.env.REACT_APP_CLIENT_URL}` +
                  "img/smartspace/clickShareImg3_1_m.png"
                }
              />
              <img
                alt=""
                src={
                  `${process.env.REACT_APP_CLIENT_URL}` +
                  "img/smartspace/clickShareImg3_2_m.png"
                }
              />
            </div>
          )}
        </div>
        <div className={style.ptWrap4}>
          <div className={style.ptItem1}>
            <div>
              <p>01</p>
              <p>무선 프레젠테이션 (대면회의)</p>
              <p>C-10</p>
              {!isMobile && !isTablet ? (
                <p>
                  C-10은 완벽한 대면 회의를 가능하게 합니다. 사용자에게 익숙한
                  노트북, 업무용 PC를 그대로 회의실로 들고 들어가 버튼을
                  연결하면
                  <br />
                  모든 회의 준비가 완성됩니다. 회의 중간에 발표자를 쉽게 변경할
                  수 있고 콘텐츠가 저장된 어떤 디바이스와도 연결이 가능합니다.
                </p>
              ) : (
                <p>
                  C-10은 완벽한 대면 회의를 가능하게 합니다. 사용자에게 익숙한
                  노트북, 업무용 PC를 그대로 회의실로 들고 들어가 버튼을
                  연결하면 모든 회의 준비가 완성됩니다. 회의 중간에 발표자를
                  쉽게 변경할 수 있고 콘텐츠가 저장된 어떤 디바이스와도 연결이
                  가능합니다.
                </p>
              )}
            </div>
            <div>
              <img
                alt=""
                src={
                  !isMobile && !isTablet
                    ? `${process.env.REACT_APP_CLIENT_URL}` +
                      "img/smartspace/clickShareImg4.png"
                    : `${process.env.REACT_APP_CLIENT_URL}` +
                      "img/smartspace/clickShareImg4_m.png"
                }
              />
            </div>
          </div>
          <div className={style.ptItem2}>
            <div className={style.ptItem2Wrap1}>
              <div className={style.ptItem2Content}>
                <div>
                  <img
                    alt=""
                    src={
                      `${process.env.REACT_APP_CLIENT_URL}` +
                      "img/smartspace/clickShareImg5.png"
                    }
                  />
                  <p>무선 프레젠테이션</p>
                </div>
                <div>
                  <label></label>
                  <font>
                    발표자가 발표하고 싶은 콘텐츠를 자유롭게 선택하여 공유 및{" "}
                    제어를 할 수 있습니다.{"\n"} 전자칠판의 판서기능을 통하여
                    회의의 집중도를 높일 수 있습니다.
                  </font>
                </div>
              </div>
              <div className={style.ptItem2Content}>
                <div>
                  <img
                    alt=""
                    src={
                      `${process.env.REACT_APP_CLIENT_URL}` +
                      "img/smartspace/clickShareImg6.png"
                    }
                  />
                  <p>원활한 화면 공유</p>
                </div>
                <div>
                  <label></label>
                  <font>
                    버튼이 연결되는 순간 발표자의 회의 자료가 연결된 화면을 통해
                    참석자들에게 선명하게 공유되며, 최대 8분할 된 화면까지
                    공유가 가능합니다.
                  </font>
                </div>
              </div>
              <div className={style.ptItem2Content}>
                <div>
                  <img
                    alt=""
                    src={
                      `${process.env.REACT_APP_CLIENT_URL}` +
                      "img/smartspace/clickShareImg7.png"
                    }
                  />
                  <p>BYOD (Bring Your Own Device)</p>
                </div>
                <div>
                  <label></label>
                  <font>
                    사용자가 신뢰하는 디바이스를 그대로 연결하여, 참여 대기
                    시간이 필요하지 않으며 버튼을 클릭하기만 하면 콘텐츠와
                    창의적인 아이디어를 빠르게 공유할 수 있습니다.
                  </font>
                </div>
              </div>
            </div>
            <div className={style.ptItem2Content2}>
              <div>
                <img
                  alt=""
                  src={
                    !isMobile && !isTablet
                      ? `${process.env.REACT_APP_CLIENT_URL}` +
                        "img/smartspace/clickShareImg8.png"
                      : `${process.env.REACT_APP_CLIENT_URL}` +
                        "img/smartspace/clickShareImg8_m.png"
                  }
                />
              </div>
              <div>
                <img
                  alt=""
                  src={
                    !isMobile && !isTablet
                      ? `${process.env.REACT_APP_CLIENT_URL}` +
                        "img/smartspace/clickShareImg9.png"
                      : `${process.env.REACT_APP_CLIENT_URL}` +
                        "img/smartspace/clickShareImg9_m.png"
                  }
                />
              </div>
            </div>
          </div>
        </div>

        <div className={style.ptWrap5}>
          <div className={style.ptItem1 + " " + style.ptItem1fix}>
            <div>
              <p>02</p>
              <p>무선 화상회의</p>
              <p>
                CX-30 <font>/</font> CX-50 gen2
              </p>
              <p>
                CX 시리즈는 회의 참석자들 사이에 완벽한 원격 상호작용을 가능하게
                합니다.
                <br /> 화상 카메라 그리고 스피커폰과의 호환으로 회의 참석자들이
                물리적 공간의 제약 없이 자료를 공유하고 <br />
                의견을 주고 받을 수 있도록 최고의 솔루션을 제공합니다.
              </p>
            </div>
            <div className={style.ptItem1Img}>
              {!isMobile && !isTablet ? (
                <>
                  {" "}
                  <img
                    alt=""
                    src={
                      `${process.env.REACT_APP_CLIENT_URL}` +
                      "img/smartspace/clickShareImg10.png"
                    }
                  />
                  <img
                    alt=""
                    src={
                      `${process.env.REACT_APP_CLIENT_URL}` +
                      "img/smartspace/clickShareImg11.png"
                    }
                  />
                </>
              ) : (
                <>
                  <div>
                    <img
                      alt=""
                      src={
                        `${process.env.REACT_APP_CLIENT_URL}` +
                        "img/smartspace/clickShareImg10_m.png"
                      }
                    />
                    <span>CX-30</span>
                  </div>
                  <div>
                    <img
                      alt=""
                      src={
                        `${process.env.REACT_APP_CLIENT_URL}` +
                        "img/smartspace/clickShareImg11_m.png"
                      }
                    />
                    <span>CX-50 gen2</span>
                  </div>
                </>
              )}
            </div>
          </div>
          <div className={style.ptItem3}>
            <div className={style.ptItem2Wrap1}>
              <div className={style.ptItem2Contentfix}>
                <div>
                  <img
                    alt=""
                    src={
                      `${process.env.REACT_APP_CLIENT_URL}` +
                      "img/smartspace/clickShareImg15.png"
                    }
                  />
                  <p>일관된 회의 경험</p>
                </div>
                <div>
                  <label></label>
                  <font>
                    ClickShare는 큰 회의실, 일상적인 회의실이나 소규모 공간이든
                    어떤 방식의 환경에서도 동일한 경험을 창출합니다.
                  </font>
                </div>
              </div>
              <div className={style.ptItem2Contentfix}>
                <div>
                  <img
                    alt=""
                    src={
                      `${process.env.REACT_APP_CLIENT_URL}` +
                      "img/smartspace/clickShareImg16.png"
                    }
                  />
                  <p>탁월한 유연성</p>
                </div>
                <div>
                  <label></label>
                  <font>
                    ClickShare 버튼이나 앱을 사용하여 MTR, 줌룸 회의실을 BYOM
                    회의로 간편하게 전환 하세요. 연결을 해제하면 시스템이 기본
                    모드로 전환됩니다.
                  </font>
                </div>
              </div>
              <div className={style.ptItem2Contentfix}>
                <div>
                  <img
                    alt=""
                    src={
                      `${process.env.REACT_APP_CLIENT_URL}` +
                      "img/smartspace/clickShareImg17.png"
                    }
                  />
                  <p>원활한 상호 운용성</p>
                </div>
                <div>
                  <label></label>
                  <font>
                    ClickShare는 모든 주요 비디오 콘퍼런싱 플랫폼과 회의실
                    장비와 완벽 하게 작동하여 기존 인프라를 최대한 활용할 수
                    있습니다.
                  </font>
                </div>
              </div>
              <div className={style.ptItem2Contentfix}>
                <div>
                  <img
                    alt=""
                    src={
                      `${process.env.REACT_APP_CLIENT_URL}` +
                      "img/smartspace/clickShareImg7.png"
                    }
                  />
                  <p>BYOD 지원</p>
                </div>
                <div>
                  <label></label>
                  <font>
                    직원이든 손님이든 ClickShare 버튼, 데스크톱 앱 또는 모바일
                    앱을 사용하여 노트북, 태블릿 또는 스마트폰에서 콘텐츠를
                    공유할 수 있습니다.
                  </font>
                </div>
              </div>
            </div>
            <div className={style.ptItem2Content3}>
              <div>
                <img
                  alt=""
                  src={
                    !isMobile && !isTablet
                      ? `${process.env.REACT_APP_CLIENT_URL}` +
                        "img/smartspace/clickShareImg12.png"
                      : `${process.env.REACT_APP_CLIENT_URL}` +
                        "img/smartspace/clickShareImg12_m.png"
                  }
                />
              </div>
              <div>
                <img
                  alt=""
                  src={
                    !isMobile && !isTablet
                      ? `${process.env.REACT_APP_CLIENT_URL}` +
                        "img/smartspace/clickShareImg13.png"
                      : `${process.env.REACT_APP_CLIENT_URL}` +
                        "img/smartspace/clickShareImg13_m.png"
                  }
                />
              </div>
            </div>
          </div>
        </div>
        <div className={style.ptWrap6}>
          <div>
            {!isMobile && !isTablet ? (
              <font>
                ClickShare는 <br /> 직원의 참여도와 생산성을 향상시킵니다.
              </font>
            ) : (
              <font>
                ClickShare는 직원의 참여도와
                <br /> 생산성을 향상시킵니다.
              </font>
            )}
          </div>
          <div className={style.ptCardList}>
            {ptInfo.map((info) => (
              <div className={style.ptCard}>
                <img
                  alt=""
                  src={
                    !isMobile && !isTablet
                      ? `${process.env.REACT_APP_CLIENT_URL + info.img}`
                      : `${process.env.REACT_APP_CLIENT_URL + info.img_m}`
                  }
                />
                <p>{info.ex}</p>
                <p>{info.title}</p>
                <p>{info.txt}</p>
              </div>
            ))}
          </div>
        </div>

        {props.type === "popup" ? (
          <div style={{ marginBottom: "70px" }}>
            <Consult />
          </div>
        ) : (
          <div className={style.device_consult_wrapper}>
            <Questions />
          </div>
        )}
      </div>
    </>
  );
}

export default Presentation;
